import type { RootState } from '@src/store/reduxstore';

export const preferencesSelect = (state: RootState) =>
  state.generalProperties?.preferences;

export const consolePreferencesSelect = (state: RootState) =>
  state.generalProperties?.preferences?.agentConsoleConfig;

export const showChatWithoutDeptToAllAgentsPreferencesSelect = (
  state: RootState
) => {
  const showChatWithoutDeptToAllAgentss =
    state.generalProperties?.preferences?.agentConsoleConfig
      ?.showChatWithoutDeptToAllAgents;

  return showChatWithoutDeptToAllAgentss ?? true;
};

export const getConsolePreferenceShowBotsInbox = (state: RootState) =>
  state.generalProperties?.preferences?.agentConsoleConfig?.showBotsInbox;

export const defaultStandardBotIdSelector = (state: RootState) =>
  state.generalProperties?.defaultStandardBotId;

export const getConsolePreferenceAllowPickupWhenBotInteraction = (
  state: RootState
) =>
  state.generalProperties?.preferences?.agentConsoleConfig
    ?.allowPickupWhenBotInteraction;
